import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AgrPageToolbarModule, AgrPrimaryActionModule } from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';

import { AgrSharedModule } from '@next/core-lib/shared';

import { AdvertisementManagementHeaderComponent } from './components/advertisement-management-header/advertisement-management-header.component';

import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';

@NgModule({
  declarations: [AdvertisementManagementHeaderComponent, TermsAndConditionsComponent],
  imports: [
    AgrSharedModule,
    AgrPageToolbarModule,
    AgrPrimaryActionModule,
    AgrFormModule,
    AgrDialogModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
  ],
  exports: [AgrSharedModule, AdvertisementManagementHeaderComponent],
  providers: [],
})
export class SharedModule {}
